export const REFERRER_ATTR = ['referrer_raw', 'referrer_domain', 'referrer_type']

export function getReferrerData() {
  const referrer = document.referrer
  const queryParamReferrer = new URL(window.location.href).searchParams.get('referrer')

  if (!referrer && !queryParamReferrer) {
    return {
      referrer_type: 'direct',
    }
  }

  // If the referrer is a query param, prioritize it over the document referrer
  if (queryParamReferrer) {
    const queryParamReferrerUrl = new URL(queryParamReferrer)

    try {
      return {
        referrer_raw: queryParamReferrer,
        referrer_domain: queryParamReferrerUrl.hostname,
        referrer_type: categorizeReferrer(queryParamReferrerUrl.hostname),
      }
    } catch (error) {
      console.error('Error getting referrer data from query param:', error)
      return {
        referrer_type: 'other',
      }
    }
  }

  try {
    const referrerUrl = new URL(referrer)
    const domain = referrerUrl.hostname
    const currentDomain = window.location.hostname

    // If the referrer is not the same as the current domain, categorize the referrer
    if (domain !== currentDomain) {
      const referrerType = categorizeReferrer(domain)

      return {
        referrer_raw: referrer,
        referrer_domain: domain,
        referrer_type: referrerType,
      }
    }

    return {
      referrer_type: 'internal',
    }
  } catch (error) {
    console.error('Error getting referrer data from document.referrer:', error)
    return {
      referrer_raw: referrer,
      referrer_type: 'other',
    }
  }
}

function categorizeReferrer(domain) {
  if (
    domain.includes('google.') ||
    domain.includes('bing.') ||
    domain.includes('yahoo.') ||
    domain.includes('duckduckgo.') ||
    domain.includes('baidu.')
  ) {
    return 'search'
  }

  if (
    domain.includes('facebook.') ||
    domain.includes('instagram.') ||
    domain.includes('twitter.') ||
    domain.includes('linkedin.') ||
    domain.includes('tiktok.') ||
    domain.includes('youtube.')
  ) {
    return 'social'
  }

  if (
    domain.includes('gmail.') ||
    domain.includes('outlook.') ||
    domain.includes('yahoo.') ||
    domain.includes('mail.')
  ) {
    return 'email'
  }

  return 'other'
}
